
export default {
    path: 'carry',
    name: 'company-carry',
    meta: {
        title: '载体进度管理'
    },
    component: () => import('@/pages/company/carryManage/Index'),
    redirect: {
        name : 'company-carry-land',
    },
    children: [
        {
            path: 'land',
            name: 'company-carry-land',
            meta: {
                title: '载体进度管理-单位管理'
            },
            component: () => import('@/pages/company/carryManage/Land'),
        },
        {
            path: 'factory',
            name: 'company-carry-factory',
            meta: {
                title: '载体进度管理-单位管理'
            },
            component: () => import('@/pages/company/carryManage/Land'),
        },
        {
            path: 'officebuilding',
            name: 'company-carry-officebuilding',
            meta: {
                title: '载体进度管理-单位管理'
            },
            component: () => import('@/pages/company/carryManage/Land'),
        },
        {
            path: 'warehouse',
            name: 'company-carry-warehouse',
            meta: {
                title: '载体进度管理-单位管理'
            },
            component: () => import('@/pages/company/carryManage/Land'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/company/carryManage/index.js